import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentEnviarComprovante from './ContentEnviarComprovante';

const SolicitacaoFluxoEnviarComprovante = () => {
  return (
    <>
      <HeaderApp />
      <ContentEnviarComprovante />
      <Bottom />
    </>
  );
};

export default SolicitacaoFluxoEnviarComprovante;
